import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./Detail'))

//	///////////////////////
//	MARK: EXPORTS
/** ★ La veille externe — `03` §3.10. Préfixe statique pour la fiche (`01` §15.2). */
export const SafetyExternalRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--safety--external']}>
    <Route path='publication/:publicationId/*' element={<Detail />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
